export enum UploadStatus {
    NotAdded = 0,
    Rejected = 1,
    RequestedToUpload = 4,
}
